/* template */
<template><div class="mpx-root-view"><div class="es-content"><div class="es-content__box es-content__card"><div class="es-content__change"><es-change-btn :value="changeBtnValue" mpxModelEvent="input" @mpxModel='__model("changeBtnValue", $event, ["value"], undefined)' v-if="(showChangeBtn)"/></div><es-card :layout="(['header'])" :style="[({'padding-bottom': '16px'})] | transRpxStyle" custom-header="es-content__miniapp_card_header" custom-body="es-content__miniapp_card_body"><div slot="header">基础信息</div><div class="es-content__name-tips"><div class="es-content__name-tips-content">{{ nameTipsContent }}</div><mpx-view @tap="handleDialogVisible" class="es-content__name-tips-entrance">填写说明<es-icon name="angle-right" color="#999999" class="es-content__name-info"/></mpx-view></div><div v-for="(item, index) in (changeBtnValue === 'Chinese'?baseContentData:englishBaseContentData)"><component :is="(item.component)" :isAddPage="(isAddPage)" :userDetail="(userDetail)" :value="baseData[item.name]" mpxModelEvent="input" @mpxModel='__model("baseData."+item.name, $event, ["value"], undefined)' :isRequiredShow="(isRequiredShow)" :isShow="(item.isShow)" :isNameDisable="(isNameDisable)" :isEnNameDisable="(isEnNameDisable)" :isPhoneDisable="(isPhoneDisable)" :isPassengerTypeDisable="(isPassengerTypeDisable)" @phone-focus="phoneFocus" :item="(item)" :selectedCardList="(selectedCardList)" :showChangeBtn="(showChangeBtn)"/></div></es-card></div><div :style="[(hasBtoom)] | transRpxStyle" class="es-content__box es-content__card" v-if="(isShowOtherContent)"><es-card custom-body="es-content__miniapp_card_body"><div v-for="(item, index) in (otherContentData)"><component :is="(item.component)" :value="baseData[item.name]" mpxModelEvent="input" @mpxModel='__model("baseData."+item.name, $event, ["value"], undefined)' :isRequiredShow="(isRequiredShow)" :isShow="(item.isShow)" :item="(item)" :selectedCardList="(selectedCardList)" :isSexDisable="(isNameDisable)" :isNationlityDisable="(isNationlityDisable)" :isBorndateDisable="(isBorndateDisable)" :isNeedCard="(isNeedCard)"/></div></es-card></div><es-card-list :isAddPage="(isAddPage)" :value="selectedCardList" mpxModelEvent="input" @mpxModel='__model("selectedCardList", $event, ["value"], undefined)' :isCardListShow="(isCardListShow)" :isRequiredShow="(isRequiredShow)" :isOneCardShow="(false)" :secret_key="(secret_key)" :cardTypeList="(cardTypeList)" :expireDateConfig="(expireDateConfig)" :aesOriginCardList="(aesOriginCardList)" :selectedCardType="(selectedCardType)" :initSelectedCardList="(initSelectedCardList)" :selected_card_type="(selected_card_type)" :isIdTypeDisable="(isIdTypeDisable)" :isIdNoDisable="(isIdNoDisable)"/><div class="es-content__box es-content__card" v-if="(isStudent && !isExemption)"><student-card></student-card></div><div class="es-content__box es-content__card" v-if="(isChild)"><child-card></child-card></div><es-tip-text :value="isRead" mpxModelEvent="input" @mpxModel='__model("isRead", $event, ["value"], undefined)' :category="(category)" v-if="(!isMyself)"/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m5abea267"}'>
  +b('content')
    +e('box')
      margin 12px
      position relative
    +e('card')
      background-color #ffffff
      border-radius 8px
      color #333333
      /deep/ .placeholder
        color #999999
      // h5用
      /deep/ .es-card__header
        line-height 38px
        font-size 16px
        font-weight bold
        margin 4px 12px
        padding 0
        border-bottom 0.5px solid rgba(235, 237, 240, 0.6)
      // h5用
      /deep/ .es-cell
        height 54px
        color #333333
        padding 10px 0
        &::after
          border-bottom 1px solid #f0f2f7
          left 76px
          right 0
      // h5用
      /deep/ .es-cell:last-child
        // &::after
        // border-bottom none
      // h5用
      /deep/ .es-cell-custom
        height 44px
        &::after
          border-bottom 1px solid #eeeeee
          left 0
          right 0
      // h5用
      /deep/ .es-cell-custom:last-child
        &::after
          border-bottom 1px solid #eeeeee
      // h5用
      /deep/ .es-field__body
        color #333333 !important
    // 小程序用
    +e('miniapp_card_header')
      line-height 38px
      font-size 16px
      font-weight bold
      margin 4px 12px
      padding 0
    // 小程序用
    +e('miniapp_card_body')
      padding 0 12px
    // 小程序用
    +e('tip-text')
      color #999999
      font-size 12px
      text-align justify
    +e('tips-icon')
      font-size 12px
      line-height 17px
      margin-right 3px
      color #999999
    +e('name-tips')
      display flex
      justify-content space-between
      align-items center
      margin -4px -12px 0 -12px
      padding 0 12px
      height 32px
      background-image linear-gradient(270deg, #FFFFFF 0%, #FFF4EE 100%)
    +e('name-tips-content')
      font-family PingFangSC-Regular
      font-size 12px
      color #FF6221
    +e('name-tips-entrance')
      display flex
      align-items center
      font-family PingFangSC-Regular
      font-size 12px
      color #666666
      text-align right
      line-height 12px
    +e('change')
      position absolute
      z-index 1
      top 80px
      right 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  wxsModules.tools = require("./index.wxs")
  global.currentModuleId = "m5abea267"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex5abea267%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex5abea267%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m5abea267"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index5abea267/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-dialog':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/dialog/index.mpx?isComponent&outputPath=components%2Findex3651661c%2Findex")),'es-contact-name':getComponent(require("./components/contact-name.mpx?isComponent&outputPath=components%2Fcontact-name58066df4%2Findex")),'es-contact-type':getComponent(require("./components/contact-type.mpx?isComponent&outputPath=components%2Fcontact-type3df7ee35%2Findex")),'es-english-surname':getComponent(require("./components/english-surname.mpx?isComponent&outputPath=components%2Fenglish-surnamec4c09c84%2Findex")),'es-contact-phone':getComponent(require("./components/contact-phone.mpx?isComponent&outputPath=components%2Fcontact-phone275fe181%2Findex")),'es-english-name':getComponent(require("./components/english-name.mpx?isComponent&outputPath=components%2Fenglish-name96f92694%2Findex")),'es-birth-date':getComponent(require("./components/birth-date.mpx?isComponent&outputPath=components%2Fbirth-date51bee4aa%2Findex")),'es-contact-sex':getComponent(require("./components/contact-sex.mpx?isComponent&outputPath=components%2Fcontact-sex3ff66779%2Findex")),'es-contact-nickname':getComponent(require("./components/contact-nickname.mpx?isComponent&outputPath=components%2Fcontact-nicknamed7d9592e%2Findex")),'es-contact-remark':getComponent(require("./components/contact-remark.mpx?isComponent&outputPath=components%2Fcontact-remarkeb471b0a%2Findex")),'es-nationlity':getComponent(require("./components/nationlity.mpx?isComponent&outputPath=components%2Fnationlity58531eb7%2Findex")),'es-card-list':getComponent(require("./components/card-list.mpx?isComponent&outputPath=components%2Fcard-list4c87468a%2Findex")),'es-save-switch':getComponent(require("./components/save-switch.mpx?isComponent&outputPath=components%2Fsave-switch5ee5a378%2Findex")),'es-tip-text':getComponent(require("./components/tip-text.mpx?isComponent&outputPath=components%2Ftip-textbb5fc7e6%2Findex")),'es-change-btn':getComponent(require("./components/change-btn.mpx?isComponent&outputPath=components%2Fchange-btnb8b68426%2Findex")),'student-card':getComponent(require("./components/student-card.mpx?isComponent&outputPath=components%2Fstudent-card09ab4f50%2Findex")),'child-card':getComponent(require("./components/child-card.mpx?isComponent&outputPath=components%2Fchild-card1c36874f%2Findex")),'es-card':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/card/index.mpx?isComponent&outputPath=components%2Findex340a2e8c%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
